import { render } from "./ApprovalFlow.vue?vue&type=template&id=6555aafd&scoped=true&ts=true"
import script from "./ApprovalFlow.vue?vue&type=script&lang=ts"
export * from "./ApprovalFlow.vue?vue&type=script&lang=ts"

import "./ApprovalFlow.vue?vue&type=style&index=0&id=6555aafd&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/air8-client-web(ali-prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6555aafd"]])

export default __exports__